import * as React from "react";
import {
  AlignHorizontalCenterRounded,
  AlignHorizontalLeftRounded,
  AlignHorizontalRightRounded,
  AlignVerticalBottomRounded,
  AlignVerticalCenterRounded,
  AlignVerticalTopRounded,
  FormatClearRounded,
  FormatStrikethroughRounded,
  FormatUnderlinedRounded,
} from "@mui/icons-material";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { X_TEXT_GUI_FIELDS } from "./XText.settings";

const { "Thème & Couleurs": theme, Général: gen, ...rest } = X_TEXT_GUI_FIELDS;

export const X_BUTTON_GUI_FIELDS: TXGUISection = {
  Général: [
    { type: "text", name: "text", label: "Donnee", defaultValue: "TEXTE" },
    {
      type: "select_option",
      name: "href",
      label: "Naviger vers",
      options: [
        { value: "NONE", label: "Aucune Page" },
        { value: "/", label: "Page d'Accueil" },
        { value: "/shop", label: "Page Boutique" },
        { value: "/categories/[slug]", label: "Page Categorie" },
        { value: "/about-us", label: "Page A Propos de nous" },
        { value: "/contact-us", label: "Page Contactez-nous" },
        { value: "/blog", label: "Page Blog" },
        { value: "/blog/[slug]", label: "Page Blog Article" },
        { value: "/checkout", label: "Page Payement" },
        { value: "/products/[slug]", label: "Page Detail du Produit" },
      ],
      defaultValue: "NONE",
    },
  ],
  "Thème & Couleurs": [
    ...(theme ?? []),
    {
      type: "boxShadow",
      name: "boxShadow",
      label: "Ombre",
      placeholder: "0px 0px 5px 5px #000000",
    },
  ],
  Badge: [
    {
      type: "toggle_option",
      name: "badgeMode",
      label: "Mode",
      options: [
        { value: "none", label: "Aucun" },
        { value: "text", label: "Texte" },
        { value: "bubble", label: "Bulle" },
        { value: "dot", label: "Point" },
      ],
      defaultValue: "none",
    },
    {
      type: "toggle_option",
      name: "badgeDataType",
      label: "Type de Donnee",
      options: [
        { value: "CART", label: "Panier" },
        { value: "FAVORITE", label: "Favoris" },
      ],
      defaultValue: "CART",
    },
    {
      type: "color",
      name: "badgeColor",
      label: "Couleur du Badge",
    },
    {
      type: "color",
      name: "badgeTextColor",
      label: "Couleur du Texte",
    },
  ],
  Placements: [
    {
      type: "toggle_option",
      name: "alignItems",
      label: "Vertical",
      options: [
        {
          value: "flex-start",
          label: "Haut",
          icon: <AlignVerticalTopRounded />,
        },
        {
          value: "center",
          label: "Centre",
          icon: <AlignVerticalCenterRounded />,
        },
        {
          value: "flex-end",
          label: "Bas",
          icon: <AlignVerticalBottomRounded />,
        },
      ],
      defaultValue: "flex-start",
    },
    {
      type: "toggle_option",
      name: "justifyContent",
      label: "Horizontal",
      options: [
        {
          value: "flex-start",
          label: "Haut",
          icon: <AlignHorizontalLeftRounded />,
        },
        {
          value: "center",
          label: "Centre",
          icon: <AlignHorizontalCenterRounded />,
        },
        {
          value: "flex-end",
          label: "Bas",
          icon: <AlignHorizontalRightRounded />,
        },
        {
          value: "space-between",
          label: "S-B",
        },
      ],
      defaultValue: "flex-start",
    },
  ],
  Survolés: [
    { type: "border", name: "hoverBorder", label: "Bordure" },
    { type: "radius", name: "hoverRadius", label: "Arrondis" },
    { type: "color", name: "hoverBgColor", label: "Couleur d'arriere plan" },
    { type: "color", name: "hoverColor", label: "Couleur du texte" },
    { type: "sizing", name: "hoverFontSize", label: "Taille de la police" },
    {
      type: "toggle_option",
      name: "hoverTextDecoration",
      label: "Decoration",
      options: [
        { value: "none", label: "Aucune", icon: <FormatClearRounded /> },
        {
          value: "underline",
          label: "Souligner",
          icon: <FormatUnderlinedRounded />,
        },
        {
          value: "line-through",
          label: "Barrer",
          icon: <FormatStrikethroughRounded />,
        },
      ],
      defaultValue: "none",
    },
  ],
  Icône: [
    { type: "icon", name: "icon", label: "nom de l'Icone (Material)" },
    {
      type: "toggle_option",
      name: "iconPosition",
      label: "Position de l'icone",
      options: [
        { value: "left", label: "Gauche" },
        {
          value: "right",
          label: "Droite",
        },
      ],
      defaultValue: "left",
    },
    { type: "color", name: "iconColor", label: "couleur de l'Icone" },
    { type: "sizing", name: "iconFontSize", label: "Taille de l'Icone" },
  ],
  ...rest,
};
